/* eslint-disable */
import { IS_WAITING, SPORTS, IS_OPEN, IS_LOGIN, CONTACT_US } from './Actions';

export const onWaiting = (state = { isWaiting: false }, action) => {
    if(action.type === IS_WAITING) {
        return Object.assign({}, state, {
            isWaiting: action.is_waiting
        })
    }

    return state;
}

export const navMenu = (state = { sports: [] }, action) => {
    if(action.type === SPORTS) {
        return Object.assign({}, state, {
            sports: action.data
        })
    }

    return state;
}

export const contact = (state = { reset: false }, action) => {
    switch(action.type) {
        case CONTACT_US:
            return Object.assign({}, state, {
                reset: action.reset
            })
        default:    
            return state;
    }
}

export const bootstrap = (state = { isOpen: false, isLoggedIn: false }, action) => {
    switch(action.type) {
        case IS_OPEN:
            return Object.assign({}, state, {
                isOpen: action.is_open
            })
        case IS_LOGIN:
            return Object.assign({}, state, {
                isLoggedIn: action.isLoggedIn
            })
    }

    return state;
}


// WEBPACK FOOTER //
// ./src/CommonReducers.js